/* Joonys: Klick auf die kleine Rating-Bar (unter dem Titel) → Smooth-Scroll
   zum großen Bewertungs-Widget (reviews.io Polaris). Delegiert + MutationObserver,
   weil beide Widgets asynchron nachladen. Inkl. Tastatur-/A11y-Support. */
(function () {
	var BAR = '.reviews-io-rating-bar-widget';
	var TARGET =
		'[data-reviewsio-widget="polaris"], reviewsio-product-reviews-widget, [id*="reviews_io_reviewsio_polaris"]';

	function scrollToReviews() {
		var t = document.querySelector(TARGET);
		if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

	// Klick funktioniert auch, wenn das Widget erst später im DOM auftaucht.
	document.addEventListener('click', function (e) {
		if (e.target.closest && e.target.closest(BAR)) {
			e.preventDefault();
			scrollToReviews();
		}
	});

	// Rating-Bar als Button auszeichnen (Cursor via CSS), Enter/Space unterstützen.
	function enhance(bar) {
		if (bar.dataset.joonysScroll) return;
		bar.dataset.joonysScroll = '1';
		bar.setAttribute('role', 'button');
		bar.setAttribute('tabindex', '0');
		bar.setAttribute(
			'aria-label',
			(window.JoonysReviewsText && window.JoonysReviewsText.scrollLabel) || 'Zu den Bewertungen springen'
		);
		bar.addEventListener('keydown', function (e) {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				scrollToReviews();
			}
		});
	}

	function scan() {
		document.querySelectorAll(BAR).forEach(enhance);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', scan);
	} else {
		scan();
	}

	new MutationObserver(scan).observe(document.documentElement, {
		childList: true,
		subtree: true,
	});
})();
/* Joonys: reviews.io Polaris ans PDF-Design angleichen (JOO018 Bewertungen).
   Was CSS nicht kann, weil die Teile in getrennten DOM-Spalten liegen:
   1) "Name, Datum" inline hinter die Sterne (als Kopie; Originale versteckt
      das CSS über .joonys-reviews-item — Vue-Knoten werden nicht verschoben,
      damit Re-Renders des Widgets nicht brechen).
   2) Tab-Label "Produktbewertungen" -> "Bewertungen" (Design-Wording).
   Observer re-applied nach Widget-Re-Renders, geschrieben wird nur bei
   Abweichung, dadurch keine Endlosschleife. */
(function () {
	var WIDGET = '[data-reviewsio-widget="polaris"]';
	// Texte aus den Theme-Übersetzungen (reviews-i18n.liquid), mit dt. Fallback
	var TEXT = window.JoonysReviewsText || {};
	var TAB_SOURCE = TEXT.tabSource || 'Produktbewertungen';
	var TAB_TARGET = TEXT.tabReviews || 'Bewertungen';
	var REQUIRED_SUFFIX = TEXT.requiredSuffix || '(erforderlich)';
	var REQUIRED_NOTE = TEXT.requiredNote || '* erforderlich';
	var REQUIRED_RE = new RegExp('\\s*' + REQUIRED_SUFFIX.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');

	function decorateItem(item) {
		var stars = item.querySelector('.item__review .R-RatingStars--sm');
		if (!stars) return;
		var nameEl = item.querySelector('.item__meta span.cssVar-authorName');
		var dateEl = item.querySelector('.c-reviewDateTime');
		var name = nameEl ? nameEl.textContent.trim() : '';
		var date = dateEl ? dateEl.textContent.trim() : '';
		var text = name && date ? name + ', ' + date : name || date;
		if (!text) return;
		var tag = item.querySelector('.joonys-review-author');
		if (!tag) {
			tag = document.createElement('span');
			tag.className = 'joonys-review-author';
			stars.insertAdjacentElement('afterend', tag);
		}
		if (tag.textContent !== text) tag.textContent = text;
		item.classList.add('joonys-reviews-item');
	}

	function apply() {
		document.querySelectorAll(WIDGET).forEach(function (widget) {
			widget.querySelectorAll('.R-ContentList__item').forEach(decorateItem);
			var tab = widget.querySelector('#product-review-tab .R-TextHeading');
			if (tab && tab.textContent.trim() === TAB_SOURCE) {
				tab.textContent = TAB_TARGET;
			}
			// Formular klappt (per CSS-Order) oben unter der Section-Überschrift
			// auf → beim ersten Erscheinen dorthin scrollen, sonst öffnet es
			// außerhalb des Viewports (der Button sitzt weiter unten).
			var form = widget.querySelector('.ElementsWidget__form');
			if (form) {
				// Mockup-Wording: "(erforderlich)" in den Labels durch * ersetzen,
				// dafür unten links in der Button-Zeile die Legende "* erforderlich".
				form.querySelectorAll('.R-TextHeading--xxxs').forEach(function (label) {
					if (label.textContent.indexOf(REQUIRED_SUFFIX) !== -1) {
						label.textContent = label.textContent.replace(REQUIRED_RE, '*');
					}
				});
				var buttonsRow = form.querySelector('.R-flex-end-xxs');
				if (buttonsRow && !buttonsRow.querySelector('.joonys-required-note')) {
					var note = document.createElement('span');
					note.className = 'joonys-required-note';
					note.textContent = REQUIRED_NOTE;
					buttonsRow.insertBefore(note, buttonsRow.firstChild);
				}
				if (!form.dataset.joonysScrolled) {
					form.dataset.joonysScrolled = '1';
					var section = widget.closest('.shopify-section');
					var target = (section && section.querySelector('.apps-section-heading')) || widget;
					target.scrollIntoView({ behavior: 'smooth', block: 'start' });
				}
			}
		});
	}

	var scheduled = false;
	function schedule() {
		if (scheduled) return;
		scheduled = true;
		setTimeout(function () {
			scheduled = false;
			apply();
		}, 50);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', apply);
	} else {
		apply();
	}

	new MutationObserver(schedule).observe(document.documentElement, {
		childList: true,
		subtree: true,
		characterData: true,
	});
})();


/* Joonys: Anker #produkt (Geschmacks-Switcher). Der Browser springt teils, bevor theme.js den
   Scroll-Handler hat, dann bleibt der Sticky-Header stehen und verdeckt den Titel. Darum nach dem
   Laden erneut zum Anker springen und den Header ausblenden, wie es theme.js beim Scrollen nach
   unten tut (Typ "on-scroll-up"). Beim Hochscrollen blendet theme.js ihn wieder ein. */
(function () {
	function jump() {
		if (location.hash !== '#produkt') return;
		var anchor = document.getElementById('produkt');
		if (!anchor) return;
		anchor.scrollIntoView({ block: 'start' });
		var header = document.querySelector('.header.is-sticky[data-sticky-type="on-scroll-up"]');
		var section = header && header.closest('.shopify-section');
		if (section && window.scrollY > 0) section.classList.add('header-sticky-hidden');
	}

	if (document.readyState === 'complete') {
		jump();
	} else {
		window.addEventListener('load', jump);
	}
})();

/* Joonys: PDP-Galerie (mivo-slider in main-product.liquid).
   1) Laedt die naechsten zwei Bilder nach der aktiven Slide vor, damit beim Wechsel keine leere
      Flaeche erscheint. Videos werden dabei nicht vorgeladen, die laden erst auf ihrer Slide.
   2) Spielt Videos stumm im Loop, aber nur auf der aktiven Slide. Verweigert der Browser Autoplay
      (z. B. Stromsparmodus) oder ist "Bewegung reduzieren" an, erscheint der mittige Play-Button.
      Das Theme startet und pausiert Videos per Hover (btyHoverMediaVideo in theme.js). Darum laeuft das
      aktive Video nach Hover-Ende weiter, und bei "Bewegung reduzieren" startet Hover es nicht. */
(function () {
	var AHEAD = 2;
	var SLIDER = '.product-gallery mivo-slider';

	// Gleiche Logik wie addLazyLoad in slider.js: echte Quelle setzen, nach dem Laden Klasse fuer das
	// Einblenden. Waehlt man die Slide spaeter aus, findet slider.js das Bild schon fertig vor.
	function preloadImage(slide) {
		if (!slide || slide.classList.contains('mivo-slider-lazy-load-has-loaded')) return;
		var img = slide.querySelector('.mivo-slider-lazy-load-img');
		var src = img && img.getAttribute('data-src');
		if (!src || img.getAttribute('src') === src) return;
		img.addEventListener(
			'load',
			function () {
				slide.classList.add('mivo-slider-lazy-load-has-loaded');
			},
			{ once: true }
		);
		img.src = src;
	}

	var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

	// Bei "Bewegung reduzieren" kein Autoplay, bis jemand selbst auf Play tippt.
	function motionBlocked(box) {
		return !!(reducedMotion && reducedMotion.matches && !box.dataset.userStarted);
	}

	function playVideo(box) {
		var video = box.querySelector('video');
		if (!video) return;
		box.dataset.active = '1';
		if (motionBlocked(box)) {
			box.classList.add('is-blocked');
			return;
		}
		var p = video.play();
		if (p && p.then) {
			p.then(function () {
				box.classList.remove('is-blocked');
			}).catch(function (err) {
				if (err && err.name === 'NotAllowedError') box.classList.add('is-blocked');
			});
		}
	}

	function pauseVideo(box) {
		var video = box.querySelector('video');
		box.dataset.active = '';
		if (video && !video.paused) video.pause();
	}

	function setupVideo(box) {
		if (box.dataset.joonysVideo) return;
		box.dataset.joonysVideo = '1';
		var video = box.querySelector('video');
		if (!video) return;

		// Fremder Start (Theme-Hover): bei "Bewegung reduzieren" sofort wieder anhalten,
		// sonst den Play-Button ausblenden, falls er noch sichtbar war.
		video.addEventListener('play', function () {
			if (motionBlocked(box)) {
				video.pause();
				return;
			}
			box.classList.remove('is-blocked');
		});

		// Fremde Pause auf der aktiven Slide wieder aufheben.
		video.addEventListener('pause', function () {
			if (box.dataset.active !== '1' || box.classList.contains('is-blocked')) return;
			setTimeout(function () {
				if (box.dataset.active === '1' && video.paused) playVideo(box);
			}, 50);
		});

		// Tippen startet das Video, wenn Autoplay blockiert war.
		box.addEventListener('click', function (e) {
			if (!box.classList.contains('is-blocked')) return;
			e.preventDefault();
			e.stopPropagation();
			box.classList.remove('is-blocked');
			box.dataset.userStarted = '1';
			playVideo(box);
		});
	}

	function setup(el, attempt) {
		var slider = el.slider;
		if (!slider) {
			// slider.js hat das Element noch nicht initialisiert.
			if ((attempt || 0) < 50) {
				setTimeout(function () {
					setup(el, (attempt || 0) + 1);
				}, 100);
			}
			return;
		}
		if (el._joonysSlider === slider) return;
		el._joonysSlider = slider;

		var slides = slider.slideNodes();
		var pageLoaded = document.readyState === 'complete';

		function update() {
			var current = slider.selectedScrollSnap();
			slides.forEach(function (slide, i) {
				var box = slide.querySelector('.joonys-pdp-video');
				if (box) {
					setupVideo(box);
					if (i === current) playVideo(box);
					else pauseVideo(box);
				} else if (pageLoaded && i > current && i <= current + AHEAD) {
					preloadImage(slide);
				}
			});
		}

		slider.on('select', update);
		update();

		// Erst nach dem Seitenladen vorladen, damit das erste Bild nicht konkurriert.
		if (!pageLoaded) {
			window.addEventListener(
				'load',
				function () {
					pageLoaded = true;
					update();
				},
				{ once: true }
			);
		}
	}

	function scan() {
		document.querySelectorAll(SLIDER).forEach(function (el) {
			setup(el, 0);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', scan);
	} else {
		scan();
	}

	// Theme-Editor baut den Slider beim Neuladen der Sektion neu auf.
	document.addEventListener('shopify:section:load', function () {
		setTimeout(scan, 0);
	});
})();
